import React, { useCallback, useState, useEffect } from 'react';
import _ from 'lodash';
import {ButtonLink, Button} from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './EnrollmentTable.metadata.json5';

const getCellPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData}
        </span>
    );
};

function EnrollmentTable(props) {
    const {data, enrollPolicy, isEnrolling} = props;     
    
    const getCellDeleteButton = (rowData, rowIndex, isLoading) => {
        return (
            
            <Button
                id={`addPolicy_${rowIndex}`}  
                disabled ={isLoading}
                onClick={ () => {enrollPolicy(rowData, data)}}         
            >
                Add
            </Button> 
        )
    }

    const generatePolicyTableOverrides = useCallback(() => {
        return {
            policyNumberColumn: { onCell: getCellPolicyNumber },
            deletePolicyColumn: { onCell: (rowData, rowIndex) => getCellDeleteButton(rowData, rowIndex, isEnrolling) }
        }
    }, [data, isEnrolling]);


    const overrideProps = {
        policiesTable: {
            data: data,
            visible: true
        },    
        ...generatePolicyTableOverrides()
    };


    const resolvers = {};

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

EnrollmentTable.propTypes = {
};

export default EnrollmentTable;
